import createTheme from './createTheme';
import { defaultProps } from './types';

const theme = createTheme(defaultProps.theme);

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js